export default {
notification: {
  read: "既読",
  unread: "未読",
  hide: "非表示",
  showAll: "すべて表示",
  loading: "読み込み中...",
  noMore: "これ以上データはありません",
  platform: "プラットフォーム",
  personal: "個人"
}
};
